import { action } from 'typesafe-actions';
import { FilterMobilePageActionTypes } from './types';

export const showFilterMobilePage = () => action(FilterMobilePageActionTypes.SHOW_FilterMobilePage)
export const hideFilterMobilePage = () => action(FilterMobilePageActionTypes.HIDE_SHOW_FilterMobilePage)